import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty, Pagination } from 'antd';
import TreatmentCard from './TreatmentCard';
import { createPaginationConfig } from '@client/utils/table/tableUtils';

const CardView = ({ data, selectedRowKeys, setSelectedRowKeys, onPageChange, showSelectedOnly }) => {
    const { t } = useTranslation();

    const pageSize = data?.size || 20;
    const results = data?.results || [];

    const pagination = useMemo(
        () => createPaginationConfig(data, pageSize, t),
        [data, pageSize, t]
    );

    const totalResults = pagination.total;

    const filteredResults = useMemo(
        () =>
            showSelectedOnly
                ? results.filter((item) => selectedRowKeys.includes(item.id))
                : results,
        [showSelectedOnly, results, selectedRowKeys]
    );

    const handleSelect = (id, checked) => {
        setSelectedRowKeys((prev) =>
            checked ? [...prev, id] : prev.filter((key) => key !== id)
        );
    };

    const handlePageChange = (page, pageSize) => {
        // Call the parent's onPageChange to trigger data fetching
        if (onPageChange) {
            onPageChange({ page, size: pageSize });
        }
    };

    if (!results.length) {
        return (
            <div className="text-center py-8">
                <Empty
                    description={t('treatment|No results found')}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            </div>
        );
    }

    return (
        <div className="card-view-container">
            {/* Cards Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {filteredResults.map((record) => (
                    <TreatmentCard
                        key={record.id}
                        record={record}
                        isSelected={selectedRowKeys.includes(record.id)}
                        onSelect={handleSelect}
                    />
                ))}
            </div>

            {/* Pagination */}
            {totalResults > pageSize && !showSelectedOnly && (
                <div className="flex justify-center mt-8">
                    <Pagination
                        {...pagination}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                        showTotal={(total, range) =>
                            `${range[0]}-${range[1]} ${t('common|of')} ${total} ${t('common|results')}`
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default CardView;